/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Share_Calendar_HeadlineInputs */

const en_us2_share_calendar_headline = /** @type {(inputs: Share_Calendar_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`training day`);
	return /** @type {LocalizedString} */ (`training days`)
	
};

const pt_br2_share_calendar_headline = /** @type {(inputs: Share_Calendar_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`dia de treino`);
	return /** @type {LocalizedString} */ (`dias de treino`)
	
};

const es_419_share_calendar_headline = /** @type {(inputs: Share_Calendar_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`día de entrenamiento`);
	return /** @type {LocalizedString} */ (`días de entrenamiento`)
	
};

const pt_pt2_share_calendar_headline = /** @type {(inputs: Share_Calendar_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`dia de treino`);
	return /** @type {LocalizedString} */ (`dias de treino`)
	
};

const fr_fr2_share_calendar_headline = /** @type {(inputs: Share_Calendar_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`jour d'entraînement`);
	return /** @type {LocalizedString} */ (`jours d'entraînement`)
	
};

const de_de2_share_calendar_headline = /** @type {(inputs: Share_Calendar_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`Trainingstag`);
	return /** @type {LocalizedString} */ (`Trainingstage`)
	
};

const it_it2_share_calendar_headline = /** @type {(inputs: Share_Calendar_HeadlineInputs) => LocalizedString} */ (i) => {
	if ((i?.days === 1 || i?.days === "1")) return /** @type {LocalizedString} */ (`giorno di allenamento`);
	return /** @type {LocalizedString} */ (`giorni di allenamento`)
	
};

/**
* | days | output |
* | --- | --- |
* | "1" | "training day" |
* | * | "training days" |
*
* @param {Share_Calendar_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_calendar_headline = /** @type {((inputs: Share_Calendar_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Calendar_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_calendar_headline(inputs)
	if (locale === "es-419") return es_419_share_calendar_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_share_calendar_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_share_calendar_headline(inputs)
	if (locale === "de-DE") return de_de2_share_calendar_headline(inputs)
	if (locale === "it-IT") return it_it2_share_calendar_headline(inputs)
	return en_us2_share_calendar_headline(inputs)
});
export { share_calendar_headline as "share.calendar_headline" }